const retainCriticalData = () => {
    let customerColumnConfigData = null;
    let vendorColumnConfigData = null;

    if (localStorage.getItem("customerColumnConfig")) {
        customerColumnConfigData = JSON.parse(localStorage.getItem("customerColumnConfig"));
    }

    if (localStorage.getItem("vendorColumnConfig")) {
        vendorColumnConfigData = JSON.parse(localStorage.getItem("vendorColumnConfig"));
    }
    localStorage.clear();

    if (customerColumnConfigData)
        localStorage.setItem("customerColumnConfig", JSON.stringify(customerColumnConfigData));
    if (vendorColumnConfigData)
        localStorage.setItem("vendorColumnConfig", JSON.stringify(vendorColumnConfigData));
};

//makes the function globally accessible
window.retainCriticalData = retainCriticalData;

document.addEventListener("DOMContentLoaded", () => {
    const bodyElement = document.querySelector("body");
    bodyElement.addEventListener("unload", retainCriticalData);
});

export { };

